export default __webpack_public_path__ + "static/media/tailwindcss.68603ef4.svg";